import React from "react";
import { fetchProductDetails  } from "../fetchData";

const useFetchProductsDetail = ({ slug }:{ slug: any }) => {
  const [products, setProducts] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listProducts();
  }, []);

  const listProducts = () => {
    setLoading(true);
    setLoaded(false);
 fetchProductDetails(slug)
      .then(
        (result) => {
          setLoading(false);
            setProducts(result.status ? result.data : {});
        },
        (error) => {
          setProducts({});
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {products,loading,loaded};
};

export default useFetchProductsDetail;
